import { api } from "../../http";

async function PutDataRRIM(rrim,dados) {
  try {
    const data = await api.put(`/rrim/${rrim}`, dados);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { PutDataRRIM };
